import { Injectable } from '@angular/core';
import { Observable, Subject, forkJoin } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';

import { TableauxEndpoint } from './tableaux-endpoint.service';
import { AuthService } from './auth.service';
import { Tableau } from '../models/tableau.model';
import { NewEquivalence } from '../models/new-equivalence.model';


@Injectable()
export class TableauxService {

  constructor(
    private authService: AuthService,
    private tableauxEndpoint: TableauxEndpoint) {
  }

  tableauExist(fromProgrammeId: number, toProgrammeId: number) {
    var params = new Array();
    params[0] = fromProgrammeId.toString();
    params[1] = toProgrammeId.toString();
    return this.tableauxEndpoint.tableauExistEndpoint<boolean>(fromProgrammeId, toProgrammeId);
  }

  getTableau(fromProgrammeId: number, toProgrammeId: number) {
    return this.tableauxEndpoint.getTableauEndpoint<Tableau>(fromProgrammeId, toProgrammeId);
  }

  createTableau(tableau: Tableau) {
    return this.tableauxEndpoint.createTableauEndpoint<Tableau>(tableau);
  }

  updateTableau(tableauId: number, tableau: Tableau) {
    return this.tableauxEndpoint.updateTableauEndpoint<Tableau>(tableauId, tableau);
  }

  createEquivalence(newEq: NewEquivalence) {
    return this.tableauxEndpoint.createEquivalenceEndpoint<Tableau>(newEq);
  }

  changeEquivalence(parametres: string) {
    return this.tableauxEndpoint.changeEquivalenceEndpoint<string>(parametres);
  }

  deleteTableau(parametres: Tableau) {
    return this.tableauxEndpoint.deleteTableauEndpoint<Tableau>(parametres);
  }

}
